/** @format */

import React, { useEffect, useRef } from 'react';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';
import {
  PageContainer,
  InputV2,
  SelectV,
  ButtonLoading,
  SimpleDialog,
  CustomCaptchaComponent,
  Icons,
  InputCurrency,
  NumberToPersianWords
} from 'components';
import { animateScroll as scroll } from 'react-scroll';
import { validator } from 'myValidation';
import { Grid, Button, Typography, CircularProgress } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import TransferCreditServices from './services/TransferCreditServices';
import { useStyles } from './Style';
import { useQuery } from 'hooks';
import { DetailsImprestTransferCreditDg, NewContactDg } from './components';
import { constBreadCrumbsTitle } from 'utility';
const ImprestTransferCredit = () => {
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    loadingField,
    setLoadingField,
    enteredCaptcha,
    setEnteredCaptcha,
    captchaId,
    setCaptchaId,
    contactId,
    setContactId,
    grantUserDataType,
    setGrantUserDataType,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    incomingUserQuery,
    setIncomingUserQuery,
    description,
    setDescription,
    amount,
    setAmount,
    foundUser,
    setFoundUser,
    guildCode,
    setGuildCode,
    isResultErrorsOpen,
    setIsResultErrorsOpen,
    rowsWithError,
    setRowsWithError,
    isNewDialogOpen,
    setIsNewDialogOpen,
    isSubmitting,
    setIsSubmitting,
    userContactInfo,
    setUserContactInfo,
    grantTypeOptions,
    loadingBtn,
    setLoadingBtn,
  } = useCustomHook();
  // -- STATES --//
  const query = useQuery();
  const classes = useStyles();
  const methods = useForm();
  const captchaRef = useRef();
  const { handleSubmit, control, register, formState: { errors } } = methods;
  const navigate = useNavigate();

  const types = {
    cellphoneNumber: 'cellphoneNumber',
    userName: 'userName',
    email: 'email',
  };

  useEffect(() => {
    // مقداری که کاربر کلمه عبور وارد میکند به اجزاری هر تغییر این افکت اجرا میشود
    methods.setValue('captchaAnswer', enteredCaptcha);
  }, [enteredCaptcha]);

  /**
   * انتقال وجه فردی
   */
  const onCheckContact = async (data) => {
    const values = methods.getValues();
    setIsConfirmModalOpen(true);
    setFoundUser(values.firstName.trim() + ' ' + values.lastName.trim());
    setAmount(data?.amount ?? null);
    setDescription(data?.description);
  };
  /**
   * افزودن مخاطب
   */
  const addContact = async () => {
    const values = methods.getValues();

    let obj = {};
    if (!firstName) {
      createToast('خطا', ' نام مخاطب را وارد نمایید.', 'danger');
      return;
    }
    if (!lastName) {
      createToast('خطا', ' نام خانوادگی مخاطب را وارد نمایید .', 'danger');
      return;
    }

    try {
      setIsSubmitting(true);
      obj[types[grantUserDataType] === 'userName' ? 'username' : types[grantUserDataType]] = [
        userContactInfo,
      ];
      const body = {
        firstName: [firstName],
        lastName: [lastName],
        targetUserId: query?.get('userId'),
        ...obj,
      };
      const result = await TransferCreditServices.addContact(body);
      handleCloseNew();
      methods.setValue('firstName', values.firstNameNew.trim());
      methods.setValue('lastName', values.lastNameNew.trim());
      setContactId(result?.result[0]?.id);
      createToast('موفق', 'مخاطب با موفقیت به لیست مخاطبین شعبه اضافه شد.', 'success');
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  /**
   * استعلام اطلاعات کاربر
   */
  const onEstelamDetails = () => {
    methods.setValue('firstName', '');
    methods.setValue('lastName', '');
    const values = methods.getValues();
    if (String(values.contact).trim().length === 0) {
      return;
    }

    let obj = {};

    if (grantUserDataType == 'cellphoneNumber') {
      if (
        String(values.contact).trim().length > 10 &&
        String(values.contact).trim()[0] == '0' &&
        String(values.contact).trim()[1] == '9'
      ) {
        const v = validator.matches(
          String(values.contact).trim() ?? '',
          /^((?:\+98|0)(\d){2}(\d){8})$/,
        );
        if (!v) {
          createToast('خطا', `تلفن همراه به درستی وارد نشده است .`, 'danger');
          return;
        }
      } else {
        createToast('خطا', `تلفن همراه به درستی وارد نشده است .`, 'danger');
        return;
      }
    }
    if (grantUserDataType == 'email') {
      const v = validator.isEmail(
        String(values.contact).trim() ?? '',
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
      );
      if (!v) {
        createToast('خطا', `پست الکترونیک بدرستی وارد نشده است.`, 'danger');
        return;
      }
    }
    if (grantUserDataType == 'userName') {
      const v = validator.matches(String(values.contact).trim() ?? '', /^[^[\u0600-\u06FF\s]*$/);
      if (!v) {
        createToast('خطا', `نام کاربری باید انگلیسی وارد شود. `, 'danger');
        return;
      }
    }
    obj[types[grantUserDataType]] = String(values.contact).trim();

    setUserContactInfo(String(values.contact).trim());
    let body = {
      targetUserId: query?.get('userId'),
      ...obj,
    };
    setLoadingField(true);
    TransferCreditServices.estelamDetails(body)
      .then((res) => {
        if (res?.result.length === 0) {
          setTimeout(() => {
            setLoadingField(false);
            methods.setValue('firstName', '');
            methods.setValue('lastName', '');
            setIsNewDialogOpen(true);
            setFirstName('');
            setLastName('');
          }, 1000);
        } else {
          setTimeout(() => {
            setLoadingField(false);
            setContactId(res?.result[0]?.id);
            methods.setValue('firstName', res?.result[0]?.firstName ?? '-');
            methods.setValue('lastName', res?.result[0]?.lastName ?? '-');
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadingField(false);
        methods.setValue('firstName', '');
        methods.setValue('lastName', '');
      });
  };
  /**
   * دیالوگ مخاطب جدید بسته مشود
   */
  const handleCloseNew = () => {
    setIsNewDialogOpen(false);
    setFirstName('');
    setLastName('');
  };

  /**
   * انتقال وجه گروهی - دیالوگ جزییاتی که نمایش داده شده ، برروی گزینه تایید کلیک بشه این تابع کال میشه
   */
  const onTransfer = async () => {
    if (loadingBtn) return;
    const captchaQuery = { captchaId, captchaAnswer: `${enteredCaptcha}` };
    setLoadingBtn(true);
    try {
      let body = {
        amount,
        currencyCode: null,
        description: description ?? '',
        uniqueId: null,
        verificationNeeded: null,
        wallet: 'PODLAND_WALLET',
        ...captchaQuery,
      };
      await TransferCreditServices.transferToContactForOther(query?.get('userId'), contactId, body);

      scroll.scrollToTop();
      resetFields();
      captchaRef?.current?.onMakeCaptcha();
      createToast('موفق', 'عملیات با موفقیت انجام شد.', 'success');
      goToList();
    } catch (error) {
      const errMsg = error?.response?.data?.message?.fa;

      if (error?.response?.status === 415) {
        if (errMsg) {
          const errs = errMsg.split('$');
          setRowsWithError(errs);
          setIsConfirmModalOpen(false);
          return setIsResultErrorsOpen(true);
        }
      }

      captchaRef?.current?.onMakeCaptcha();
    } finally {
      setLoadingBtn(false);
      handleCloseModal();
      captchaRef?.current?.onMakeCaptcha();
    }
  };

  // -- OTHER FUNCTIONS --//
  const handleCloseModal = () => {
    setIsConfirmModalOpen(false);
  };

  const goToList = () => {
    navigate('/Imprest');
  };

  const resetFields = () => {
    setAmount(null);
    setDescription(null);
    setGuildCode(null);
    setIncomingUserQuery(null);
  };

  const handleCloseErrorsModal = () => {
    setIsResultErrorsOpen(false);
    setRowsWithError([]);
  };

  const hintText = 'در این بخش می‌توانید از طرف شعبه به مخاطبین ایشان انتقال وجه انجام دهید.';
  return (
    <PageContainer
      title="انتقال وجه تکی از طرف تنخواه‌گردان"
      className={classes.root}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.IMPREST_IMPREST_TRANSFERCREDIT}
    >
      <SimpleDialog
        title="خطا در انتقال وجه"
        icon={<Icons icon='WarningTriangle' color="#F44336" size="22" />}
        open={isResultErrorsOpen}
        actions={
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: -8 }}
            onClick={handleCloseErrorsModal}
          >
            بستن
          </Button>
        }
        onClose={handleCloseErrorsModal}
      >
        <Typography className={classes.alertTitle}>
          انتقال وجه با خطا مواجه شد. موارد زیر را اصلاح کنید و دوباره تلاش کنید:
        </Typography>
        {rowsWithError?.map((v, k) => (
          <li key={k}>{v}</li>
        ))}
      </SimpleDialog>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onCheckContact)} className={classes.form} autoComplete="off">
          <Grid container spacing={2} xs={8}>
            <Grid item xs={12} md={6}>
              <SelectV
                name="type"
                options={grantTypeOptions}
                label="نوع اطلاعات مخاطب"
                control={control}
                register={register}
                rules={['required']}
                required
                onChangeFunc={(k, e) => {
                  setGrantUserDataType(e?.target?.value);
                  methods.setValue('contact', '');
                  methods.setValue('firstName', '');
                  methods.setValue('lastName', '');
                }}
                defaultValue={grantUserDataType}
                errors={errors}
                disabled={incomingUserQuery?.userInfo}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                rules={[
                  'required',
                  ...grantTypeOptions.find((v) => v?.value === grantUserDataType)?.rules,
                ]}
                englishNumber={
                  grantTypeOptions.find((v) => v?.value === grantUserDataType)?.englishNumber
                }
                name="contact"
                label={grantTypeOptions.find((v) => v?.value === grantUserDataType)?.label}
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                dir="ltr"
                placeholder=""
                onBlur={onEstelamDetails}
              />
              {loadingField && <CircularProgress size={20} className={classes.buttonProgress} />}
            </Grid>
          </Grid>
          <Grid container spacing={2} xs={8}>
            <Grid item xs={12} md={6}>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                name="firstName"
                label="نام"
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                defaultValue={firstName}
                placeholder=""
                rules={['required']}
                disabled={true}
                style={{
                  backgroundColor: '#eeeeee',
                  cursor: 'not-allowed',
                  color: ' #757575',
                  borderRadius: 8,
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputV2
                label="نام خانوادگی"
                errors={errors}
                name="lastName"
                control={control}
                register={register}
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                placeholder=""
                defaultValue={lastName}
                rules={['required']}
                disabled={true}
                style={{
                  backgroundColor: '#eeeeee',
                  cursor: 'not-allowed',
                  color: ' #757575',
                  borderRadius: 8,
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} xs={8}>
            <Grid item xs={12} md={6}>
              <InputCurrency
                fullWidth
                label="مبلغ"
                errors={errors}
                name="amount"
                control={control}
                register={register}
                dir="ltr"
                onChangeValue={(v) => setAmount(v)}
                decimalPlaces={0}
                minimumValue={0}
                rules={['required']}
              />
              <Typography className={classes.amountString}>
                  <NumberToPersianWords number={amount} />
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <InputV2
                control={control}
                register={register}
                errors={errors}
                name="description"
                label="توضیحات"
                mainStyle={{ width: '100%', marginLeft: 0, marginRight: 0 }}
                fullWidth
                placeholder=""
                defaultValue={null}
              />
            </Grid>
          </Grid>

          <Grid container>
            <InputV2
              errors={errors}
              control={control}
              register={register}
              name="captchaAnswer"
              label="کد امنیتی"
              forceValue={enteredCaptcha}
              onChangeValue={(e) => {
                const value = e.target.value;
                if (value.length > 5) {
                  e.preventDefault();
                  setEnteredCaptcha(value.slice(0, 5));
                } else {
                  setEnteredCaptcha(value);
                }
              }}
              englishNumber
              rules={['required']}
              fullWidth
              dir="ltr"
            />

            <CustomCaptchaComponent
              ref={captchaRef}
              setCaptchaId={setCaptchaId}
              setEnteredCaptcha={setEnteredCaptcha}
              pageTitle="انتقال وجه از طرف تنخواه‌گردان - /ImprestTransferCredit"
            />
          </Grid>
          <Grid container spacing={2} xs={12} style={{ marginTop: 8 }} justifyContent="flex-end">
            <Grid item >
              <ButtonLoading
                name="انتقال وجه"
                variant="contained"
                color="primary"
                type="submit"
              />

            </Grid>
          </Grid>
        </form>
      </FormProvider>
      {/* جزییات پرداخت  */}
      <DetailsImprestTransferCreditDg
        isConfirmModalOpen={isConfirmModalOpen}
        handleCloseModal={handleCloseModal}
        onTransfer={onTransfer}
        isLoading={loadingBtn}
        foundUser={foundUser}
        amount={amount}
        classes={classes}
      />
      {/* تعریف مخاطب جدید */}
      <NewContactDg
        isNewDialogOpen={isNewDialogOpen}
        isSubmitting={isSubmitting}
        handleCloseNew={handleCloseNew}
        setGrantUserDataType={setGrantUserDataType}
        grantUserDataType={grantUserDataType}
        grantTypeOptions={grantTypeOptions}
        addContact={addContact}
        setFirstName={setFirstName}
        firstName={firstName}
        userContactInfo={userContactInfo}
        setLastName={setLastName}
        lastName={lastName}
        errors={errors}
        control={control}
        register={register}
        classes={classes}
        methods={methods}
      />
    </PageContainer>
  );
};

export default ImprestTransferCredit;
